<template>
    <div id="cancelPage">
        <div class="d-flex flex-column rounded align-items-center text-center py-4 px-lg-5 px-3 bg-white">
            <div class="d-flex flex-column align-items-center text-center p-2">
                <img alt="" src="/img/hcpay/opg-cancel-image.svg" class="img-responsive">
                <span class="font-md font-weight-bold text-capitalize my-3">
                    Transaction Cancelled
                </span>
                <span class="font-sm text-secondary margin-bottom">
                    Your transaction has been cancelled. You may try to transact again.
                </span>
                <span v-if="this.$root.$data.transaction.referenceNumber" class="font-sm text-secondary text-danger cancel-margin-bottom">
                    Reference No. {{ this.$root.$data.transaction.referenceNumber }}
                </span>
                <span v-else class="font-sm text-secondary text-danger cancel-margin-bottom">
                    Reference No. {{ this.$root.$data.referenceNumber }}
                </span>
                <div class="col-lg-11 col-xs-12 d-flex flex-column align-items-center"></div>
            </div>
        </div>
    </div>
</template>
<script>
import moment from 'moment';
export default {
    created() {
        let g4Params = {
            'userId': this.$root.$data.account.userId,
            'cuid': this.$root.$data.account.cuid,
            'ip': this.$root.transaction.ipAddress,
            'user_agent': this.$root.$data.analyticsData.userAgent,
            'phone': this.$root.$data.analyticsData.phone,
            'operating_system': this.$root.$data.analyticsData.operatingSystem.name+"V"+this.$root.$data.analyticsData.operatingSystem.version,
            'browser': this.$root.$data.analyticsData.browser.name+"V"+this.$root.$data.analyticsData.browser.version,
            'transaction_type': this.$root.$data.transaction.referenceNumber.substring(0, 2),
            'transaction_reference': this.$root.$data.transaction.referenceNumber,
        }       
        this.$root.triggerG4Event('trxn_cancelled_page',g4Params) 
    },
}
</script>
<style scoped>
    .transactionCompleteIcon {
        height: auto;
        width: 7rem;
    }
    .lazada-hc-logo {
        /* Layout Properties */
        top: 14px;
        left: 36px;
        width: 100%;
        height: 52px;
        margin-bottom: 41px;
        /* UI Properties */
        background: transparent url('/img/lazada/logos_desktop.png') center no-repeat padding-box;
        opacity: 1;
    }
    .padding-y {
        padding: 16px 0 16px;
    }
    .cancel-margin-bottom {
        margin-bottom: 80px;
    }
    .margin-bottom {
        margin-bottom: 24px;
    }
</style>